import {Request} from './Request';
import {AvailabilityType} from '../enums/availability.type.enum';

export class ChangeAvailabilityRequest implements Request {

    private connectorId: number;
    chargePointSelectList: string[];
    private availType: AvailabilityType;

    constructor(chargePointSelectList: string[], connectorId?: number, availType?: AvailabilityType) {
        this.connectorId = connectorId;
        this.chargePointSelectList = chargePointSelectList;
        this.availType = availType;
    }

    get connector_id(): number {
        return this.connectorId;
    }

    set connector_id(value: number) {
        this.connectorId = value;
    }

    get avail_type(): AvailabilityType {
        return this.availType;
    }

    set avail_type(value: AvailabilityType) {
        this.availType = value;
    }

    public toString = (): string => {
        return `ChangeAvailabilityRequest (connectorId: ${this.connectorId}, availType: ${this.availType})`;
    }
}
